export default "__VITE_ASSET__D01wh6fP__"